import { forwardRef, HTMLProps, Ref } from "react";
import { Textarea } from "../Textarea/Textarea";

export type InputOnlyFieldProps = HTMLProps<HTMLInputElement> & {
  placeholder?: string;
  type?: 'text' | 'password' | 'email' | 'number' | 'date';
  inErrorState?: boolean;
  multiline?: boolean;
  rows?: number;
};

/** INPUT FIELD COMPONENT */
export const Input = forwardRef(
  (props: InputOnlyFieldProps, ref: Ref<HTMLInputElement | HTMLTextAreaElement>) => {
    const { placeholder, type, inErrorState, multiline, rows, ...inputProps } = props;
    
    const baseClasses = "h-10 border mt-1 rounded px-3 w-full focus:outline-none text-sm";
    const errorClasses = inErrorState
      ? "bg-red-50 focus-visible:border-red-600 border-red-500"
      : "bg-gray-50 focus-visible:border-gray-400";
    const classes = `${baseClasses} ${errorClasses}`;
    
    if (multiline) {
      return (
        <Textarea
          ref={ref as Ref<HTMLTextAreaElement>}
          inErrorState={inErrorState}
          placeholder={placeholder}
          rows={rows ?? 3}
          {...(inputProps as Omit<HTMLProps<HTMLTextAreaElement>, 'type'>)}
        />
      );
    }

    return (
      <input
        type={type ?? 'text'}
        ref={ref as Ref<HTMLInputElement>}
        {...inputProps}
        className={classes}
        placeholder={placeholder}
      />
    );
  }
);